module.exports = __webpack_public_path__ + "static/img/7.a020e5b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/4/zh/7.png
// module id = uMgJ
// module chunks = 0